export class LocalStorage {
    constructor(loggedInUserId) {
        this.loggedInUserId = loggedInUserId
    }

    setItem(key, value, appendUserId = true) {
        const k = appendUserId ? key + this.loggedInUserId : key
        try {
            localStorage.setItem(k, JSON.stringify(value))
        } catch (e) {
            console.error(`can't store (${k}, ${value}) cause: \n`, e)
        }
    }

    getItem(key, withUserId = true) {
        const k = withUserId ? key + this.loggedInUserId : key
        try {
            return JSON.parse(localStorage.getItem(k))
        } catch (e) {
            console.error(`can't retrieve stored value with key ${k} cause: \n`, e)
            return null
        }
    }

    removeItem(key, appendUserId = true) {
        const k = appendUserId ? key + this.loggedInUserId : key
        try {
            localStorage.removeItem(k)
        } catch (e) {
            console.error(`can't remove stored value with key ${k} cause: \n`, e)
        }
    }
}

let instance

export const initLocalStorage = (loggedInUserId) => {
    instance = new LocalStorage(loggedInUserId)
}

export const getLocalStorage = () => instance


// WEBPACK FOOTER //
// ./web/js/util/LocalStorage.js